module.exports = __webpack_public_path__ + "static/djawn_banner-d7de0abea39e068403d2dd6a6a12b9c6.png";